import TwoFactorInitialConfigViewModel from '@/Components/TwoFaktorAuth/InitialConfig/TwoFactorInitialConfigViewModel';
import ComponentManager from '@/Management/ComponentManager';
import ViewFactory from '@/Factories/ViewFactory';
import TwoFactorInitialConfigView from '@/Components/TwoFaktorAuth/InitialConfig/TwoFactorInitialConfigView';
import {IViewFactoryConstructorParameter} from '#/CoreFrameInterfaces';
import {ITwoFactorInitialConfigViewModelConstructorParameter} from '#/DefaultViewExtensionInterfaces';

interface ITwoFactorInitialConfiConstructorParameter extends IViewFactoryConstructorParameter {
    viewModelParameters: ITwoFactorInitialConfigViewModelConstructorParameter;
}

export default class TwoFactorInitialConfigViewFactory extends ViewFactory {
    private TwoFactorInitialConfigViewModel = ComponentManager.getViewModel<typeof TwoFactorInitialConfigViewModel>('TwoFactorInitialConfigViewModel');
    private TwoFactorInitialConfigView = ComponentManager.getView<typeof TwoFactorInitialConfigView>('TwoFactorInitialConfigView');

    public viewModel: TwoFactorInitialConfigViewModel;

    public constructor(private params: ITwoFactorInitialConfiConstructorParameter) {
        super(params);
    }

    public getView(): JQuery<HTMLElement> {
        if (this.viewModel == null) {
            this.viewModel = this.createViewModel();
        }
        
        if (this.view == null) {
            this.view = this.createView(this.viewModel);
        }

        const tuple = this.view.getTuple();
        return tuple.view;
    }
    
    protected createViewModel(): TwoFactorInitialConfigViewModel {
        return new this.TwoFactorInitialConfigViewModel({ ...this.params.viewModelParameters, locator: '2fa' });
    }

    protected createView(viewModel: TwoFactorInitialConfigViewModel): TwoFactorInitialConfigView {
        return new this.TwoFactorInitialConfigView(viewModel, this.createRootElement('TwoFactorInitialConfig'));
    }
}

ComponentManager.setFactory('TwoFactorInitialConfig', TwoFactorInitialConfigViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');